document.addEventListener('cf:ready', function () {
  var form = document.querySelector('form[data-cf-form="pvtdYa"]');
  if (!form || !form.cfForm) return;

  function getUrlParameter(name) {
    var match = location.search.match(new RegExp('[?&]' + name + '=([^&#]*)'));
    return match ? decodeURIComponent(match[1].replace(/\+/g, ' ')) : '';
  }

  [
    { columnKey: 'utm_source', urlParam: 'utm_source', defaultValue: 'none' },
    { columnKey: 'utm_medium', urlParam: 'utm_medium', defaultValue: 'none' },
    { columnKey: 'utm_campaign', urlParam: 'utm_campaign', defaultValue: 'none' },
    { columnKey: 'utm_content', urlParam: 'utm_content', defaultValue: 'none' },
    { columnKey: 'r_id', urlParam: 'r_id', defaultValue: 'none' },
    { columnKey: 'ref_by', urlParam: 'ref_by', defaultValue: 'none' },
    { columnKey: 'email', urlParam: 'email', defaultValue: '' },
    { columnKey: 'preferred_name', urlParam: 'preferred_name', defaultValue: '' }
  ].forEach(function (field) {
    var value = getUrlParameter(field.urlParam) || field.defaultValue;
    if (value) form.cfForm.setFieldValue(field.columnKey, value);
  });
});
